<script>
import {
  ServicePackageCardElementMixin,
} from "%/dynamic-component-editor/standard-components/service-package-card/service-package-card-element-mixin";
import { formatCurrency } from "@bloglovin/vue-framework";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "ServicePackagePrice",
  elementPanelSettings: {
    displayName: "Price",
    displayIcon: "text-alt",
    elementGroup: "servicePackageElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [ServicePackageCardElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.formatCurrency(
        parseFloat(this.entity.price),
        "USD",
        "en-US",
        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
      );
    },
  },
  methods: {
    formatCurrency,
  },
};
</script>
